<template>
  <div class="nav-container" ref="navContainer">
    <div 
      v-for="(item, index) in navItems" 
      :key="index" 
      class="nav-item"
      :class="{ 'active': currentIndex === index }"
      @click="handleNavClick(index)"
      ref="navItems"
    >
      {{ item }}
    </div>
    <div 
      class="nav-indicator" 
      :style="indicatorStyle"
      :class="[indicatorType]"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'AdvancedNav',
  props: {
    navItems: {
      type: Array,
      default: () => ['首页', '产品', '服务', '关于', '联系']
    },
    initialIndex: {
      type: Number,
      default: 0
    },
    // 指示器类型：'fixed'固定长度 | 'auto'跟随导航项宽度
    indicatorType: {
      type: String,
      default: 'auto',
      validator: value => ['fixed', 'auto'].includes(value)
    },
    // 固定长度时的宽度(px)
    fixedWidth: {
      type: Number,
      default: 21
    },
    // 指示器位置：'center'居中 | 'full'对齐导航项
    indicatorPosition: {
      type: String,
      default: 'center',
      validator: value => ['center', 'full'].includes(value)
    }
  },
  data() {
    return {
      currentIndex: this.initialIndex,
      itemWidths: [],
      itemPositions: []
    }
  },
  computed: {
    indicatorStyle() {
      if (this.itemPositions.length === 0) return {};
      
      const currentItem = this.$refs.navItems[this.currentIndex];
      const baseLeft = this.itemPositions[this.currentIndex];
      
      // 计算宽度
      const width = this.indicatorType === 'fixed' 
        ? this.fixedWidth 
        : currentItem.offsetWidth;
      
      // 计算位置偏移
      let left = baseLeft;
      if (this.indicatorPosition === 'center') {
        left += (currentItem.offsetWidth - width) / 2;
      }
      
      return {
        width: `${width}px`,
        transform: `translateX(${left}px)`,
        transition: 'transform 0.3s ease, width 0.3s ease'
      };
    }
  },
  mounted() {
    this.calculatePositions();
    window.addEventListener('resize', this.debounceCalculatePositions);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debounceCalculatePositions);
  },
  methods: {
    handleNavClick(index) {
      this.currentIndex = index;
      this.$emit('nav-change', index);
    },
    calculatePositions() {
      this.$nextTick(() => {
        const items = this.$refs.navItems;
        if (!items || items.length === 0) return;
        
        this.itemWidths = Array.from(items).map(item => item.offsetWidth);
        this.itemPositions = Array.from(items).map(item => item.offsetLeft);
      });
    },
    debounceCalculatePositions: _.debounce(function() {
      this.calculatePositions();
    }, 200)
  }
}
</script>

<style scoped>
.nav-container {
  position: relative;
  display: flex;
  width: 100%;
  padding: 10px 0;
}

.nav-item {
  flex: 1;
  text-align: center;
  padding: 5px 0;
  cursor: pointer;
  transition: color 0.3s;
  position: relative;
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: bold;
font-size: 19px;
color: #333333;
font-style: normal;
text-transform: none;
}

.nav-item.active {
  color: var(--tech-primary);
  font-weight: bold;
}

.nav-indicator {
  position: absolute;
  bottom: 0;
  height: 4px;
  background: var(--tech-primary);
  transition: all 0.3s ease;
}

/* 固定长度样式 */
.nav-indicator.fixed {
  width: 30px;
}

/* 自动宽度样式 */
.nav-indicator.auto {
  transition-property: transform, width;
}
</style>